/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import { followTagsUtils } from '../../common/utils/followTagsApi';
import { components } from '@glowingblue-orell-thalia-common';

const { FollowingFilterDropdown, Separator } = components;
import followingPageOptions from '../../common/helpers/followingPageOptions';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
import type { ReviewListRequestParams } from '../types';

export default function () {
	if (app.initializers.has('fof/follow-tags')) {
		followTagsUtils.followingPageOptions = followingPageOptions;
		// Called once so the replacement is what ends up cached.
		followTagsUtils.followingPageOptions('forum.index.following');

		extend(FollowingFilterDropdown.prototype, 'options', function (options) {
			options.add(
				'reviews-separator',
				<Separator data-label={app.translator.trans('glowingblue-orell-rezensionen.forum.index.following.section_label')} />
			);
			this.addFilterOption(options, 'reviews');
			this.addFilterOption(options, 'reviewsTags');

			if (app.initializers.has('ianm-follow-users')) {
				this.addFilterOption(options, 'reviewsUsers');
			}
		});

		extend(DiscussionListState.prototype, 'requestParams', function (rawParams) {
			const params = rawParams as ReviewListRequestParams;

			if (!followTagsUtils.isFollowingPage() || !app.session.user) return;

			// Installed by fof/follow-tags, which ships no typings.
			const state = this as { followTags?: string };

			if (!state.followTags) {
				state.followTags = followTagsUtils.getDefaultFollowingFiltering();
			}
			const followTags = state.followTags as string;

			if (app.current.get('routeName') === 'following') {
				if (followTags.indexOf('reviews') != -1) {
					delete params.filter['-isReview'];
					params.filter['isReview'] = true;
				}
				switch (followTags) {
					case 'reviewsTags':
						delete params.filter.subscription;
						params.filter['following-tag'] = true;
						break;
					case 'reviewsUsers':
						delete params.filter.subscription;
						params.filter['following-users'] = true;
						break;
					default:
						break;
				}
			}
		});
	}
}
